import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../contexts/TranslationContext';
import Button from '../../../shared/Button';
import './OrderCancellationPage.css';

const OrderCancellationPage = () => {
  const { translate } = useTranslation();
  const navigate = useNavigate();

  const handleReturnToHome = () => {
    navigate('/');
  };

  return (
    <div className="cancellation-container">
      <h1>{translate('orderCancellationPage.header.title')}</h1>
      <p>{translate('orderCancellationPage.content.p1')}</p>
      <p>{translate('orderCancellationPage.content.p2')}</p>
      <Button size="medium" onClick={handleReturnToHome}>
        {translate('orderCancellationPage.returnToHome')}
      </Button>
    </div>
  );
};

export default OrderCancellationPage;
